import { useTranslation } from "react-i18next";
import type { AppLanguage } from "../i18n";

type Values = Record<string, string | number>;
type Dictionary = Record<string, string>;

const en: Dictionary = {
  Billetera: "Wallet",
  Inicio: "Home",
  Mercado: "Market",
  "Mis equipos": "My miners",
  Finanzas: "Finance",
  Cuenta: "Account",
  "Saltar al contenido": "Skip to content",
  "Navegación principal": "Main navigation",
  Notificaciones: "Notifications",
  "Cambiar idioma": "Change language",
  "Volver a mi cuenta": "Back to my account",
  "Volver al equipo": "Back to team",
  Editar: "Edit",
  Confirmar: "Confirm",
  Cancelar: "Cancel",
  Guardar: "Save",
  Depositar: "Deposit",
  Retirar: "Withdraw",
  Movimientos: "Transactions",
  Retiros: "Withdrawals",
  "Mi equipo": "My team",
  Invitar: "Invite",
  "Saldo disponible": "Available balance",
  "Saldo personal": "Personal balance",
  "Saldo del equipo": "Team balance",
  Monto: "Amount",
  Canal: "Channel",
  Todo: "All",
  "Procesando…": "Processing…",
  "Cargando historial…": "Loading history…",
  "Cargando miembros…": "Loading members…",
  "En revisión": "Under review",
  Completado: "Completed",
  Rechazado: "Rejected",
  Activo: "Active",
  "Sin activación": "Not activated",
  Depósito: "Deposit",
  Retiro: "Withdrawal",
  "Ingreso de minería": "Mining income",
  "Ingreso de fondos": "Fund income",
  "Aporte a fondos": "Fund contribution",
  "Compra de equipo de minería": "Mining equipment purchase",
  "Canje de CDK": "CDK redemption",
  Saldo: "Balance",
  "Ajuste de puntos": "Points adjustment",
  "Ajuste de saldo": "Balance adjustment",
  "Beneficio de equipo": "Team benefit",
  "Bono de primer depósito": "First deposit bonus",
  "Canje de puntos a saldo": "Points-to-balance exchange",
  "Canje de saldo a puntos": "Balance-to-points exchange",
  "Puntos usados en sorteo": "Points used in a draw",
  "Puntos ganados en sorteo": "Points won in a draw",
  "Premio de sorteo": "Draw prize",
  "Bono de registro": "Registration bonus",
  "Experiencia obtenida": "Experience earned",
  "Puntos por ingreso": "Income points",
  "Puntos por depósito": "Deposit points",
  "Beneficio de invitación": "Invitation benefit",
  "Venta de equipo": "Equipment sale",
  "Puntos por compra del equipo": "Equipment purchase points",
  "Puntos por compra": "Purchase points",
  "Ingreso de potencia de cómputo": "Computing-power income",
  "Transferencia de ingreso del equipo": "Equipment income transfer",
  "Español (Ecuador)": "Spanish (Ecuador)",
  English: "English",
  简体中文: "Simplified Chinese",
  "Centro de cuenta": "Account center",
  "Mi espacio": "My space",
  "Revisar asistencia": "Check attendance",
  Mensajes: "Messages",
  Nivel: "Level",
  "Progreso al siguiente nivel": "Progress to next level",
  Faltan: "Remaining",
  Puntos: "Points",
  "Ingreso del equipo": "Team income",
  "Dinero y registros": "Money and records",
  "Métodos de retiro": "Withdrawal methods",
  "Días transcurridos": "Elapsed days",
  "Próximo ingreso": "Next income",
  Portafolio: "Portfolio",
  "Mis posiciones": "My positions",
  Activas: "Active",
  Finalizadas: "Completed",
  "Cargando posiciones…": "Loading positions…",
  "No pudimos cargar tus posiciones.": "We could not load your positions.",
  "No tienes posiciones activas": "You have no active positions",
  "No tienes posiciones finalizadas": "You have no completed positions",
  "En rendimiento": "Earning",
  Finalizada: "Completed",
  "Capital invertido": "Invested capital",
  "Rendimiento acumulado": "Accumulated return",
  Tasa: "Rate",
  Progreso: "Progress",
  "días restantes": "days remaining",
  Oportunidades: "Opportunities",
  "Productos disponibles": "Available products",
  "El monto debe ser múltiplo de $50.": "The amount must be a multiple of $50.",
  "Cuenta bancaria y datos de pago": "Bank account and payment details",
  "Historial de movimientos": "Transaction history",
  "Depósitos, retiros e ingresos": "Deposits, withdrawals and income",
  "Comunidad y beneficios": "Community and benefits",
  "Actividad de niveles y miembros": "Level and member activity",
  "Invitar amigos": "Invite friends",
  "Código, enlace y recompensas": "Code, link and rewards",
  "Puntos y premios": "Points and rewards",
  "Canjes y beneficios disponibles": "Available redemptions and benefits",
  "Ayuda y configuración": "Help and settings",
  "Novedades de tu cuenta": "Account updates",
  "Seguridad y perfil": "Security and profile",
  "Datos personales y contraseña": "Personal details and password",
  "Servicio al cliente": "Customer service",
  "Comunícate con nuestro equipo": "Contact our team",
  "Descargar aplicación": "Download app",
  "Acceso a la versión oficial": "Access the official version",
  "Ir al inicio de sesión": "Go to sign in",
  "Cerrar sesión": "Sign out",
  "Operación digital": "Digital operations",
  "Capacidad que se entiende.": "Capacity you can understand.",
  "Progreso que se puede seguir.": "Progress you can track.",
  "Administra equipos, capital y beneficios desde un espacio diseñado para ser claro en cada paso.":
    "Manage equipment, capital and benefits in a space designed for clarity at every step.",
  "Información antes de cada decisión": "Information before every decision",
  "Reglas, montos y estados visibles en contexto.":
    "Rules, amounts and statuses visible in context.",
  "Crear una cuenta": "Create an account",
  "Bienvenido de nuevo": "Welcome back",
  "Empieza tu recorrido": "Start your journey",
  "Ingresa a tu espacio": "Sign in to your space",
  "Completa tus datos. Los campos obligatorios están señalados.":
    "Complete your details. Required fields are marked.",
  "Usa el número registrado y tu contraseña de acceso.":
    "Use your registered number and access password.",
  "Nombre de usuario": "Username",
  "Número de celular": "Mobile number",
  "Ingresa tu número móvil de Ecuador sin el cero inicial.":
    "Enter your Ecuador mobile number without the leading zero.",
  "Contraseña de acceso": "Access password",
  "Mínimo 6 caracteres": "At least 6 characters",
  "Ocultar contraseña": "Hide password",
  "Mostrar contraseña": "Show password",
  "Contraseña de fondos": "Funds password",
  "Protege tus operaciones": "Protect your operations",
  "Código de invitación": "Invitation code",
  "Opcional según configuración": "Optional depending on settings",
  Código: "Code",
  Ingresar: "Sign in",
  "¿Ya tienes una cuenta?": "Already have an account?",
  "¿Todavía no tienes una cuenta?": "Don’t have an account yet?",
  "Iniciar sesión": "Sign in",
  Registrarme: "Register",
  "Soporte multilingüe": "Multilingual support",
  "No pudimos completar la solicitud. Revisa tus datos.":
    "We could not complete the request. Check your details.",
  "Panel personal": "Personal dashboard",
  Hola: "Hello",
  "Ver notificaciones": "View notifications",
  "Ocultar saldo": "Hide balance",
  "Mostrar saldo": "Show balance",
  hoy: "today",
  "Tu operación está al día": "Your operation is up to date",
  "2 equipos conectados y sin solicitudes pendientes.":
    "2 connected miners and no pending requests.",
  "Acciones rápidas": "Quick actions",
  "Agregar fondos": "Add funds",
  "Solicitar retiro": "Request withdrawal",
  "Crecer en equipo": "Grow your team",
  Premios: "Rewards",
  "Beneficios activos": "Active benefits",
  "Operación en vivo": "Live operation",
  "Tu ecosistema GOP ALA": "Your GOP ALA ecosystem",
  "Ver equipos": "View miners",
  "En funcionamiento": "Running",
  "2 equipos producen ahora": "2 miners are producing now",
  "Rendimiento combinado estimado de": "Estimated combined output of",
  "por día": "per day",
  "Administrar equipos": "Manage miners",
  "Ingreso acumulado": "Total income",
  "Desde el inicio de contratos": "Since contracts began",
  "Puntos disponibles": "Available points",
  "Canjeables en recompensas": "Redeemable for rewards",
  "Selección recomendada": "Recommended selection",
  "Equipos con propósito": "Purpose-built miners",
  "Explorar mercado": "Explore market",
  "Referencia de mercado": "Market reference",
  "Activos destacados": "Featured assets",
  "Datos en vivo": "Live data",
  "Datos actualizados": "Updated data",
  "Conectando al mercado…": "Connecting to market…",
  "Mercado temporalmente no disponible": "Market temporarily unavailable",
  "Cambio 24 h": "24h change",
  "Mercado spot": "Spot market",
  "Información de referencia.": "Reference information.",
  "Los criptoactivos no son moneda de curso legal en Ecuador. Los valores pueden variar.":
    "Crypto assets are not legal tender in Ecuador. Values may vary.",
  "Soporte cercano": "Support nearby",
  "¿Necesitas ayuda?": "Need help?",
  "Nuestro equipo puede orientarte sobre tu cuenta y tus operaciones.":
    "Our team can guide you with your account and operations.",
  "Hablar con soporte": "Contact support",
  Equipo: "Miner",
  "Equipo de minería": "Mining equipment",
  "Ingreso diario": "Daily income",
  Duración: "Duration",
  días: "days",
  Desde: "From",
  Ver: "View",
  "Más rentable": "Highest return",
  Popular: "Popular",
  "Para empezar": "Starter",
  "Planificación financiera": "Financial planning",
  "Dos productos distintos, presentados con reglas y rendimientos separados.":
    "Two distinct products with separate rules and returns.",
  "Capital disponible": "Available capital",
  "generado hoy": "generated today",
  Fondos: "Funds",
  "Producto de staking": "Staking product",
  "Producto de fondo": "Fund product",
  "Rendimiento estimado del ciclo": "Estimated cycle return",
  "Revisar condiciones": "Review terms",
  "Información antes de decidir.": "Information before deciding.",
  "El rendimiento mostrado es estimado. La confirmación final debe incluir las reglas recibidas desde el servidor.":
    "Displayed returns are estimates. Final confirmation must include the rules received from the server.",
  "Ciclo Esmeraldas": "Esmeraldas Cycle",
  "Ciclo Cotopaxi": "Cotopaxi Cycle",
  "Ciclo Galápagos": "Galápagos Cycle",
  "Fondo Pacífico": "Pacific Fund",
  "Fondo Andes": "Andes Fund",
  "Fondo Amazonía": "Amazon Fund",
  "Centro de operación": "Operations center",
  "Estado, rendimiento y tiempo restante de tus contratos.":
    "Status, performance and remaining time for your contracts.",
  "Equipos activos": "Active miners",
  "Ingreso de hoy": "Today’s income",
  "Precio de compra": "Purchase price",
  "Saldo de fondos": "Fund balance",
  Finalizado: "Finished",
  Todos: "All",
  "En marcha": "Running",
  "Por activar": "To activate",
  Finalizados: "Completed",
  Activar: "Activate",
  "Ver detalle": "View details",
  "Catálogo activo": "Active catalog",
  "Mercado de equipos": "Equipment market",
  "Compara capacidad, duración y rendimiento estimado antes de decidir.":
    "Compare capacity, duration and estimated performance before deciding.",
  Filtros: "Filters",
  "Mayor rendimiento": "Highest return",
  "Menor inversión": "Lowest investment",
  "Ciclo corto": "Short cycle",
  "Capacidad alta": "High capacity",
  "Volver al mercado": "Back to market",
  "Potencia de cómputo": "Computing power",
  "Contrato de equipo": "Equipment contract",
  "Una configuración equilibrada para distribuir capacidad de cómputo durante un ciclo definido.":
    "A balanced setup that distributes computing capacity over a defined cycle.",
  "Inversión del contrato": "Contract investment",
  "Ingreso diario estimado": "Estimated daily income",
  "Ingreso total estimado": "Estimated total income",
  "Panel de rendimiento diario": "Daily performance dashboard",
  "Seguimiento del ciclo en tiempo real": "Real-time cycle tracking",
  "Registro completo de movimientos": "Complete transaction record",
  "Continuar con la compra": "Continue purchase",
  "Revisa reglas, disponibilidad y condiciones antes de confirmar.":
    "Review rules, availability and terms before confirming.",
  "Comunidad GOP ALA": "GOP ALA community",
  "Consulta el tamaño y la actividad de tu comunidad, organizada por nivel.":
    "View your community size and activity by level.",
  "Miembros en 3 niveles": "Members across 3 levels",
  "La actividad se actualiza desde el servidor.":
    "Activity is updated from the server.",
  "No pudimos cargar el resumen del equipo.":
    "We could not load the team summary.",
  "Equipo directo": "Direct team",
  "Personas invitadas directamente por ti.": "People invited directly by you.",
  "Segundo nivel": "Second level",
  "Miembros conectados a tu equipo directo.":
    "Members connected to your direct team.",
  "Tercer nivel": "Third level",
  "Alcance ampliado de tu comunidad.": "Extended reach of your community.",
  "Miembros del nivel": "Level members",
  "Estado de activación de las personas que pertenecen a este nivel.":
    "Activation status of people in this level.",
  "No pudimos cargar los miembros.": "We could not load members.",
  "Miembro del nivel": "Level member",
  "Este nivel aún está vacío": "This level is still empty",
  "Comparte tu enlace para ampliar tu comunidad.":
    "Share your link to grow your community.",
  "Comparte tu enlace personal y acompaña a tu comunidad desde el primer paso.":
    "Share your personal link and support your community from the first step.",
  "Mi enlace personal": "My personal link",
  "Crecer se siente mejor cuando es claro.":
    "Growth feels better when it is clear.",
  "Envía este enlace solo a personas que conozcan las condiciones del servicio.":
    "Send this link only to people who understand the service terms.",
  "Consultando enlace…": "Loading link…",
  "Enlace no disponible": "Link unavailable",
  "Copiar enlace": "Copy link",
  "Enlace copiado": "Link copied",
  "Compartir invitación": "Share invitation",
  "Cómo funciona": "How it works",
  "Tres pasos sencillos": "Three simple steps",
  "Comparte tu enlace": "Share your link",
  "El registro queda asociado a tu invitación.":
    "Registration is linked to your invitation.",
  "Tu contacto crea su cuenta": "Your contact creates an account",
  "Debe revisar y completar los datos solicitados.":
    "They must review and complete the requested details.",
  "Sigue la actividad": "Track activity",
  "El nuevo miembro aparecerá en el nivel correspondiente.":
    "The new member will appear in the corresponding level.",
  "No prometas rentabilidad ni condiciones distintas a las publicadas por GOP ALA.":
    "Do not promise returns or terms different from those published by GOP ALA.",
  "Únete a GOP ALA Ecuador": "Join GOP ALA Ecuador",
  "Conoce GOP ALA y crea tu cuenta desde mi invitación.":
    "Discover GOP ALA and create your account from my invitation.",
  "Depositar fondos": "Deposit funds",
  "Elige un canal disponible, revisa el importe y confirma antes de salir al proveedor de pago.":
    "Choose an available channel, review the amount and confirm before continuing to the payment provider.",
  "Monto a depositar": "Deposit amount",
  "Montos rápidos": "Quick amounts",
  "Canal de pago": "Payment channel",
  "Consultando canales…": "Loading channels…",
  "No pudimos cargar los canales de pago.":
    "We could not load payment channels.",
  "Procesamiento protegido por el proveedor":
    "Protected processing by the provider",
  "Revisar depósito": "Review deposit",
  "Confirma los datos": "Confirm details",
  "Cambio referencial": "Reference rate",
  "Pago con control": "Payment with control",
  "GOP ALA nunca solicita tu clave bancaria. Verifica el monto y el dominio del proveedor antes de continuar.":
    "GOP ALA never asks for your bank password. Verify the amount and provider domain before continuing.",
  "Moneda base: dólar estadounidense": "Base currency: US dollar",
  "El canal se obtiene del servidor": "The channel is provided by the server",
  "La orden se crea una sola vez": "The order is created only once",
  "Billetera · Retiros": "Wallet · Withdrawals",
  "Selecciona el saldo de origen y confirma el monto que deseas recibir en tu cuenta vinculada.":
    "Select the source balance and confirm the amount you want to receive in your linked account.",
  "Monto a retirar": "Withdrawal amount",
  "El monto supera el saldo disponible.":
    "The amount exceeds the available balance.",
  "Vincula un método de retiro": "Link a withdrawal method",
  "Necesitas una cuenta bancaria antes de solicitar un retiro.":
    "You need a bank account before requesting a withdrawal.",
  Vincular: "Link",
  "Revisar solicitud": "Review request",
  "Resumen del retiro": "Withdrawal summary",
  Origen: "Source",
  Solicitud: "Request",
  Solicitar: "Submit request",
  "El monto neto y cualquier comisión aplicable se confirmarán según las reglas vigentes del servidor.":
    "The net amount and any applicable fees will be confirmed according to current server rules.",
  "Antes de retirar": "Before withdrawing",
  "Los retiros pasan por revisión. La cuenta de destino debe pertenecer al titular registrado.":
    "Withdrawals are reviewed. The destination account must belong to the registered holder.",
  "Ver historial": "View history",
  "Historial de retiros": "Withdrawal history",
  "Volver a retirar": "Back to withdrawal",
  "No pudimos cargar el resumen.": "We could not load the summary.",
  "Total recibido": "Total received",
  Solicitudes: "Requests",
  "Aún no hay retiros": "No withdrawals yet",
  Recibido: "Received",
  Actividad: "Activity",
  "Consulta depósitos, ingresos, compras y solicitudes de retiro desde un solo lugar.":
    "View deposits, income, purchases and withdrawal requests in one place.",
  "No pudimos cargar el historial.": "We could not load the history.",
  Movimiento: "Transaction",
  "Aún no hay movimientos": "No transactions yet",
  "Las operaciones aparecerán aquí cuando se registren.":
    "Operations will appear here when recorded.",
  "Saldo anterior": "Previous balance",
  "Saldo posterior": "New balance",
  "Seguridad financiera": "Financial security",
  "Método de retiro": "Withdrawal method",
  "Administra la cuenta bancaria donde recibirás tus retiros.":
    "Manage the bank account where you will receive withdrawals.",
  "Consultando cuenta…": "Loading account…",
  "CUENTA VINCULADA": "LINKED ACCOUNT",
  "Cuenta registrada": "Registered account",
  "Se usará para los próximos retiros bancarios.":
    "It will be used for upcoming bank withdrawals.",
  "Editar información": "Edit information",
  "La edición está bloqueada por la configuración de seguridad.":
    "Editing is locked by security settings.",
  "Nombre del titular": "Account holder name",
  Teléfono: "Phone",
  "Número de identificación": "Identification number",
  "Ingresa los 13 dígitos de tu documento": "Enter the 13 digits of your identification document",
  "Documento de identidad (CI) requerido para procesar retiros bancarios en Ecuador.":
    "Identity document (CI) required to process bank withdrawals in Ecuador.",
  "Institución financiera": "Financial institution",
  "Selecciona un banco": "Select a bank",
  "Número de cuenta": "Account number",
  "Tipo o detalle de cuenta": "Account type or details",
  Opcional: "Optional",
  "Ej. Cuenta de ahorros": "E.g. Savings account",
  "Tus datos, protegidos": "Your data, protected",
  "Comprueba que el titular y el número de cuenta sean correctos. No mostramos controles de eliminación que el flujo original no habilitaba.":
    "Verify the account holder and number. We do not show deletion controls that the original flow did not enable.",
  "Simulación completada. En una cuenta real continuarías al proveedor de pago.":
    "Simulation completed. In a real account you would continue to the payment provider.",
  "La orden se creó, pero el enlace de pago recibido no es válido.":
    "The order was created, but the payment link received is invalid.",
  "Solicitud enviada. Puedes seguir su estado en el historial de retiros.":
    "Request sent. You can track its status in withdrawal history.",
  "Método de retiro guardado correctamente.":
    "Withdrawal method saved successfully.",
  "Solicitud procesada correctamente.": "Request processed successfully.",
  "Comprueba que el titular y el número de cuenta sean correctos antes de guardar.":
    "Verify the account holder and account number before saving.",
  Volver: "Back",
  "Centro de premios": "Rewards center",
  "Aplicación oficial": "Official app",
  "Selección de monto, canal y confirmación de pago.":
    "Amount selection, channel and payment confirmation.",
  "Saldo personal y del equipo con reglas visibles.":
    "Personal and team balances with visible rules.",
  "Historial unificado con filtros y estados.":
    "Unified history with filters and statuses.",
  "Gestión segura de información bancaria.":
    "Secure management of bank information.",
  "Código, enlace, QR y opciones para compartir.":
    "Code, link, QR and sharing options.",
  "Actividad y miembros organizados por nivel.":
    "Activity and members organized by level.",
  "Saldo de puntos, origen y canjes disponibles.":
    "Point balance, sources and available redemptions.",
  "Sorteos, reglas y registro de resultados.":
    "Draws, rules and result history.",
  "Avisos importantes sobre tu cuenta.":
    "Important notices about your account.",
  "Datos personales, avatar, nombre y contraseña.":
    "Personal details, avatar, name and password.",
  "Acceso al canal oficial de soporte configurado por el servidor.":
    "Access to the official support channel configured by the server.",
  "Descarga de Android o acceso de iOS según el dispositivo.":
    "Android download or iOS access depending on the device.",
  "Beneficios diarios": "Daily benefits",
  "Asistencia diaria": "Daily check-in",
  "Completa la secuencia y recibe puntos en cada jornada.":
    "Complete the sequence and receive points each day.",
  "Progreso semanal": "Weekly progress",
  "Puntos recibidos": "Points received",
  "Próxima recompensa": "Next reward",
  "Completado hoy": "Completed today",
  "Registrar asistencia": "Check in",
  "Asistencia registrada correctamente.": "Check-in completed successfully.",
  "Esta semana": "This week",
  "Recompensas por día": "Daily rewards",
  "Cargando…": "Loading…",
  Día: "Day",
  puntos: "points",
  "Consulta avisos y novedades relacionados con tu cuenta.":
    "View notices and updates related to your account.",
  "Cargando mensajes…": "Loading messages…",
  "No pudimos cargar los mensajes.": "We could not load messages.",
  "No tienes mensajes nuevos": "You have no new messages",
  "Los avisos de tu cuenta aparecerán aquí.":
    "Account notices will appear here.",
  "Tu actividad y los movimientos recientes ya están disponibles.":
    "Your activity and recent transactions are now available.",
  "Seguridad de la cuenta": "Account security",
  "Recuerda verificar el dominio antes de confirmar cualquier operación.":
    "Remember to verify the domain before confirming any operation.",
  "Puntos y beneficios": "Points and benefits",
  "Centro de puntos": "Points center",
  "Convierte puntos y saldo con las tasas disponibles en tu cuenta.":
    "Convert points and balance using the rates available for your account.",
  "Puntos a saldo": "Points to balance",
  "Saldo a puntos": "Balance to points",
  "Cantidad de puntos": "Points amount",
  PTS: "PTS",
  "Tasa actual": "Current rate",
  "No pudimos cargar la tasa de cambio.": "We could not load the exchange rate.",
  "USD {{amount}} = Ecuador {{converted}}":
    "USD {{amount}} = Ecuador {{converted}}",
  "Cambio a moneda ecuatoriana": "Conversion to Ecuadorian currency",
  "Conversión estimada en Ecuador": "Estimated conversion in Ecuador",
  "Recibirás aproximadamente": "You will receive approximately",
  "Conversión completada.": "Conversion completed.",
  Convertir: "Convert",
  "Historial de puntos": "Points history",
  "Perfil y acceso": "Profile and access",
  "Cambiar foto": "Change photo",
  "Foto actualizada.": "Photo updated.",
  "Selecciona una imagen JPG, PNG o WebP.": "Select a JPG, PNG or WebP image.",
  "La imagen no puede superar 5 MB.": "The image cannot exceed 5 MB.",
  "Administra tu nombre visible y la contraseña de acceso.":
    "Manage your display name and access password.",
  "Número no disponible": "Number unavailable",
  "Información personal": "Personal information",
  "Nombre visible": "Display name",
  "Nombre actualizado.": "Name updated.",
  "Guardar cambios": "Save changes",
  Acceso: "Access",
  "Cambiar contraseña": "Change password",
  "Contraseña actual": "Current password",
  "Nueva contraseña": "New password",
  "Confirmar contraseña": "Confirm password",
  "Las contraseñas no coinciden.": "Passwords do not match.",
  "Contraseña actualizada.": "Password updated.",
  "Actualizar contraseña": "Update password",
  Ayuda: "Help",
  "Comunícate con el equipo de soporte a través del canal oficial.":
    "Contact the support team through the official channel.",
  "¿En qué podemos ayudarte?": "How can we help?",
  "Nuestro equipo atiende consultas relacionadas con tu cuenta, operaciones y seguridad.":
    "Our team handles questions about your account, transactions and security.",
  "Abrir soporte": "Open support",
  Seguridad: "Security",
  "Acceso, contraseña y protección de la cuenta.":
    "Access, password and account protection.",
  Operaciones: "Transactions",
  "Depósitos, retiros y movimientos de saldo.":
    "Deposits, withdrawals and balance transactions.",
  "Datos personales, equipo y beneficios.":
    "Personal information, team and benefits.",
  "Aplicación GOP ALA": "GOP ALA app",
  "Elige la versión correspondiente a tu dispositivo.":
    "Choose the version for your device.",
  "Tu cuenta, siempre disponible": "Your account, always available",
  "Accede a tus equipos, saldo y movimientos desde la aplicación oficial.":
    "Access your miners, balance and transactions from the official app.",
  "No pudimos obtener los enlaces de descarga.":
    "We could not retrieve the download links.",
  "Participa y consulta los resultados recientes.":
    "Participate and view recent results.",
  "Elige tu momento": "Choose your moment",
  cupón: "coupon",
  "Sigue participando": "Keep trying",
  Participar: "Play",
  Resultado: "Result",
  Cerrar: "Close",
  Aviso: "Notice",
  Carrusel: "Carousel",
  Novedades: "Updates",
  Siguiente: "Next",
  "Ir a la imagen": "Go to image",
  Servicios: "Services",
  "Tiempo de operación": "Operating time",
  Horas: "Hours",
  Minutos: "Minutes",
  Segundos: "Seconds",
  "Código de verificación": "Verification code",
  "Enviar código": "Send code",
  "Código enviado.": "Code sent.",
  "Ingresa el código de verificación.": "Enter the verification code.",
  "Ingresa el código de invitación.": "Enter the invitation code.",
  "No pudimos cargar la configuración de registro.":
    "We could not load the registration settings.",
  "Finaliza en": "Ends in",
  Reglas: "Rules",
  "Nivel 1 activo": "Level 1 active",
  "Nivel 2 activo": "Level 2 active",
  "Nivel 3 activo": "Level 3 active",
  "Actividad reciente": "Recent activity",
  "Últimos ganadores": "Latest winners",
  "Usuario GOP ALA": "GOP ALA user",
  "Mi historial": "My history",
  "Volver al sorteo": "Back to the draw",
  "Aún no hay participaciones": "No entries yet",
  "Sin premio": "No prize",
  Obtenido: "Received",
  "Volver a premios": "Back to rewards",
  "Beneficios GOP ALA": "GOP ALA benefits",
  "Administra tus beneficios desde un solo lugar.":
    "Manage all your benefits in one place.",
  "Convierte puntos y consulta sus movimientos.":
    "Convert points and view their transactions.",
  "Participa y revisa los resultados recientes.":
    "Participate and review recent results.",
  "Mis cupones": "My coupons",
  "Consulta cupones disponibles y utilizados.":
    "View available and used coupons.",
  "Canjear CDK": "Redeem CDK",
  "Ingresa un código y recibe su beneficio.":
    "Enter a code and receive its benefit.",
  "Código de regalo": "Gift code",
  "Abre regalos y consulta el historial.": "Open gifts and view history.",
  "Consulta el valor y el estado de tus cupones.":
    "View the value and status of your coupons.",
  Disponibles: "Available",
  Utilizados: "Used",
  "Cupón de descuento": "Discount coupon",
  Disponible: "Available",
  Utilizado: "Used",
  "No hay cupones": "No coupons",
  "Tus cupones aparecerán aquí.": "Your coupons will appear here.",
  "Ingresa el código exactamente como aparece.":
    "Enter the code exactly as shown.",
  "Código CDK": "CDK code",
  "Código canjeado": "Code redeemed",
  "Canjear código": "Redeem code",
  "Historial CDK": "CDK history",
  "Ingresa tu código para recibir el beneficio asociado.":
    "Enter your code to receive its benefit.",
  "Abre tu regalo": "Open your gift",
  "Cada código válido puede utilizarse una sola vez.":
    "Each valid code can be used once.",
  Recibiste: "You received",
  "Abrir regalo": "Open gift",
  "Historial de regalos": "Gift history",
  "Sin registros": "No records",
  "Historial de conversiones": "Conversion history",
  "Consulta las conversiones realizadas entre puntos y saldo.":
    "View conversions between points and balance.",
  "Revisa conversiones anteriores entre puntos y saldo.":
    "Review previous conversions between points and balance.",
  Consumido: "Consumed",
  "Computación en la nube": "Cloud computing",
  Minería: "Mining",
  Ordenar: "Sort",
  Recomendados: "Recommended",
  "Cargando equipos…": "Loading equipment…",
  "No pudimos cargar los equipos.": "We could not load equipment.",
  "No hay equipos disponibles": "No equipment available",
  "Cargando equipo…": "Loading equipment…",
  "Equipo no disponible": "Equipment unavailable",
  Cantidad: "Quantity",
  Máximo: "Maximum",
  "Reducir cantidad": "Decrease quantity",
  "Aumentar cantidad": "Increase quantity",
  "Cupón disponible": "Available coupon",
  Total: "Total",
  "Compra completada correctamente.": "Purchase completed successfully.",
  "Confirmar compra": "Confirm purchase",
  "Saldo insuficiente.": "Insufficient balance.",
  "No pudimos cargar tus equipos.": "We could not load your equipment.",
  "No tienes equipos activos": "You have no active equipment",
  "No tienes equipos finalizados": "You have no completed equipment",
  Vender: "Sell",
  "Confirmar activación": "Confirm activation",
  "Confirmar venta": "Confirm sale",
  "Inicia sesión para consultar los equipos disponibles":
    "Sign in to view available equipment",
  "Monto invertido": "Invested amount",
  "Saldo de moneda": "Coin balance",
  "Beneficio acumulado": "Accumulated profit",
  "No pudimos cargar los productos financieros.":
    "We could not load the financial products.",
  "Inicia sesión para consultar los productos disponibles":
    "Sign in to view available products",
  "Ingreso estimado": "Estimated income",
  "Límite de compra": "Purchase limit",
  Inversión: "Investment",
  Comprar: "Buy",
  "No hay productos disponibles": "No products available",
  "Confirmar inversión": "Confirm investment",
  "Ingresos del equipo": "Team income",
  Reclutamiento: "Recruitment",
  "Sobre GOP ALA": "About GOP ALA",
  "Perfil de la empresa": "Company profile",
  Anterior: "Previous",
  Actual: "Current",
  "Cargar más": "Load more",
  "No hay registros": "No records",
  "No pudimos cargar el contenido.": "We could not load the content.",
  "No pudimos cargar los movimientos.": "We could not load the transactions.",
  "Depositar en fondos": "Deposit to funds",
  "Transferir saldo del equipo": "Transfer team balance",
  "Transferencia completada.": "Transfer completed.",
  Continuar: "Continue",
  "Confirmar transferencia": "Confirm transfer",
};

const zh: Dictionary = {
  Billetera: "钱包",
  Inicio: "首页",
  Mercado: "市场",
  "Mis equipos": "我的矿机",
  Finanzas: "理财",
  Cuenta: "账户",
  "Saltar al contenido": "跳至主要内容",
  "Navegación principal": "主导航",
  Notificaciones: "通知",
  "Cambiar idioma": "切换语言",
  "Volver a mi cuenta": "返回账户",
  "Volver al equipo": "返回团队",
  Editar: "编辑",
  Confirmar: "确认",
  Cancelar: "取消",
  Guardar: "保存",
  Depositar: "充值",
  Retirar: "提现",
  Movimientos: "资金明细",
  Retiros: "提现记录",
  "Mi equipo": "我的团队",
  Invitar: "邀请",
  "Saldo disponible": "可用余额",
  "Saldo personal": "个人余额",
  "Saldo del equipo": "团队余额",
  Monto: "金额",
  Canal: "支付渠道",
  Todo: "全部",
  "Procesando…": "处理中…",
  "Cargando historial…": "正在加载记录…",
  "Cargando miembros…": "正在加载成员…",
  "En revisión": "审核中",
  Completado: "已完成",
  Rechazado: "已拒绝",
  Activo: "已激活",
  "Sin activación": "未激活",
  Depósito: "充值",
  Retiro: "提现",
  "Ingreso de minería": "矿机收益",
  "Ingreso de fondos": "理财收益",
  "Aporte a fondos": "理财投入",
  "Compra de equipo de minería": "购买矿机",
  "Canje de CDK": "CDK兑换",
  Saldo: "余额",
  "Ajuste de puntos": "积分调整",
  "Ajuste de saldo": "余额调整",
  "Beneficio de equipo": "团队奖励",
  "Bono de primer depósito": "首充奖励",
  "Canje de puntos a saldo": "积分兑换余额",
  "Canje de saldo a puntos": "余额兑换积分",
  "Puntos usados en sorteo": "抽奖消耗积分",
  "Puntos ganados en sorteo": "抽奖获得积分",
  "Premio de sorteo": "抽奖奖励",
  "Bono de registro": "注册奖励",
  "Experiencia obtenida": "获得经验",
  "Puntos por ingreso": "收益积分",
  "Puntos por depósito": "充值积分",
  "Beneficio de invitación": "邀请奖励",
  "Venta de equipo": "出售矿机",
  "Puntos por compra del equipo": "购买矿机积分",
  "Puntos por compra": "消费积分",
  "Ingreso de potencia de cómputo": "算力收益",
  "Transferencia de ingreso del equipo": "矿机收益转入",
  "Español (Ecuador)": "西班牙语（厄瓜多尔）",
  English: "英语",
  简体中文: "简体中文",
  "Centro de cuenta": "账户中心",
  "Mi espacio": "我的空间",
  "Revisar asistencia": "查看签到",
  Mensajes: "消息",
  Nivel: "等级",
  "Progreso al siguiente nivel": "下一等级进度",
  Faltan: "还需",
  Puntos: "积分",
  "Ingreso del equipo": "团队收益",
  "Dinero y registros": "资金与记录",
  "Métodos de retiro": "提现方式",
  "Días transcurridos": "已运行天数",
  "Próximo ingreso": "下次收益",
  Portafolio: "投资组合",
  "Mis posiciones": "我的持仓",
  Activas: "持有中",
  Finalizadas: "已完成",
  "Cargando posiciones…": "正在加载持仓…",
  "No pudimos cargar tus posiciones.": "无法加载持仓。",
  "No tienes posiciones activas": "暂无持有中的理财产品",
  "No tienes posiciones finalizadas": "暂无已完成的理财产品",
  "En rendimiento": "收益中",
  Finalizada: "已完成",
  "Capital invertido": "投入本金",
  "Rendimiento acumulado": "累计收益",
  Tasa: "收益率",
  Progreso: "进度",
  "días restantes": "天到期",
  Oportunidades: "理财机会",
  "Productos disponibles": "可用理财产品",
  "El monto debe ser múltiplo de $50.": "转入金额必须为 $50 的整数倍。",
  "Cuenta bancaria y datos de pago": "银行卡及收款信息",
  "Historial de movimientos": "资金明细",
  "Depósitos, retiros e ingresos": "充值、提现与收益",
  "Comunidad y beneficios": "团队与福利",
  "Actividad de niveles y miembros": "等级与成员动态",
  "Invitar amigos": "邀请好友",
  "Código, enlace y recompensas": "邀请码、链接与奖励",
  "Puntos y premios": "积分与奖励",
  "Canjes y beneficios disponibles": "可用兑换与福利",
  "Ayuda y configuración": "帮助与设置",
  "Novedades de tu cuenta": "账户动态",
  "Seguridad y perfil": "安全与资料",
  "Datos personales y contraseña": "个人资料与密码",
  "Servicio al cliente": "在线客服",
  "Comunícate con nuestro equipo": "联系我们的团队",
  "Descargar aplicación": "下载应用",
  "Acceso a la versión oficial": "获取官方版本",
  "Ir al inicio de sesión": "前往登录",
  "Cerrar sesión": "退出登录",
  "Operación digital": "数字化运营",
  "Capacidad que se entiende.": "看得懂的算力。",
  "Progreso que se puede seguir.": "可追踪的进度。",
  "Administra equipos, capital y beneficios desde un espacio diseñado para ser claro en cada paso.":
    "在清晰易懂的空间中管理矿机、资金与收益。",
  "Información antes de cada decisión": "每次决策前都有充分信息",
  "Reglas, montos y estados visibles en contexto.":
    "规则、金额与状态一目了然。",
  "Crear una cuenta": "创建账户",
  "Bienvenido de nuevo": "欢迎回来",
  "Empieza tu recorrido": "开始使用 GOP ALA",
  "Ingresa a tu espacio": "登录你的账户",
  "Completa tus datos. Los campos obligatorios están señalados.":
    "请完善资料，必填项已明确标注。",
  "Usa el número registrado y tu contraseña de acceso.":
    "请输入注册号码和登录密码。",
  "Nombre de usuario": "用户名",
  "Número de celular": "手机号码",
  "Ingresa tu número móvil de Ecuador sin el cero inicial.":
    "请输入厄瓜多尔手机号，不含开头的 0。",
  "Contraseña de acceso": "登录密码",
  "Mínimo 6 caracteres": "至少 6 个字符",
  "Ocultar contraseña": "隐藏密码",
  "Mostrar contraseña": "显示密码",
  "Contraseña de fondos": "资金密码",
  "Protege tus operaciones": "保护你的资金操作",
  "Código de invitación": "邀请码",
  "Opcional según configuración": "根据配置选填",
  Código: "代码",
  Ingresar: "登录",
  "¿Ya tienes una cuenta?": "已有账户？",
  "¿Todavía no tienes una cuenta?": "还没有账户？",
  "Iniciar sesión": "立即登录",
  Registrarme: "立即注册",
  "Soporte multilingüe": "支持多语言",
  "No pudimos completar la solicitud. Revisa tus datos.":
    "请求未完成，请检查输入信息。",
  "Panel personal": "个人面板",
  Hola: "你好",
  "Ver notificaciones": "查看通知",
  "Ocultar saldo": "隐藏余额",
  "Mostrar saldo": "显示余额",
  hoy: "今日",
  "Tu operación está al día": "当前运行状态正常",
  "2 equipos conectados y sin solicitudes pendientes.":
    "2 台矿机在线，无待处理申请。",
  "Acciones rápidas": "快捷操作",
  "Agregar fondos": "添加资金",
  "Solicitar retiro": "申请提现",
  "Crecer en equipo": "发展团队",
  Premios: "奖励",
  "Beneficios activos": "当前福利",
  "Operación en vivo": "实时运营",
  "Tu ecosistema GOP ALA": "你的 GOP ALA 生态",
  "Ver equipos": "查看矿机",
  "En funcionamiento": "运行中",
  "2 equipos producen ahora": "2 台矿机正在产出",
  "Rendimiento combinado estimado de": "预计综合收益",
  "por día": "每天",
  "Administrar equipos": "管理矿机",
  "Ingreso acumulado": "累计收益",
  "Desde el inicio de contratos": "自合约开始以来",
  "Puntos disponibles": "可用积分",
  "Canjeables en recompensas": "可兑换奖励",
  "Selección recomendada": "推荐选择",
  "Equipos con propósito": "精选矿机",
  "Explorar mercado": "浏览市场",
  "Referencia de mercado": "市场参考",
  "Activos destacados": "热门资产",
  "Datos en vivo": "实时数据",
  "Datos actualizados": "行情已更新",
  "Conectando al mercado…": "正在连接市场…",
  "Mercado temporalmente no disponible": "市场暂时不可用",
  "Cambio 24 h": "24小时涨跌",
  "Mercado spot": "现货市场",
  "Información de referencia.": "参考信息。",
  "Los criptoactivos no son moneda de curso legal en Ecuador. Los valores pueden variar.":
    "加密资产并非法定货币，价格可能波动。",
  "Soporte cercano": "便捷支持",
  "¿Necesitas ayuda?": "需要帮助？",
  "Nuestro equipo puede orientarte sobre tu cuenta y tus operaciones.":
    "我们的团队可协助处理账户与操作问题。",
  "Hablar con soporte": "联系客服",
  Equipo: "矿机",
  "Equipo de minería": "矿机设备",
  "Ingreso diario": "每日收益",
  Duración: "周期",
  días: "天",
  Desde: "起价",
  Ver: "查看",
  "Más rentable": "收益优选",
  Popular: "热门",
  "Para empezar": "入门推荐",
  "Planificación financiera": "理财规划",
  "Dos productos distintos, presentados con reglas y rendimientos separados.":
    "两类不同产品，规则与收益分别展示。",
  "Capital disponible": "可用资金",
  "generado hoy": "今日产生",
  Fondos: "基金",
  "Producto de staking": "质押产品",
  "Producto de fondo": "基金产品",
  "Rendimiento estimado del ciclo": "周期预计收益",
  "Revisar condiciones": "查看规则",
  "Información antes de decidir.": "决策前请充分了解。",
  "El rendimiento mostrado es estimado. La confirmación final debe incluir las reglas recibidas desde el servidor.":
    "所示收益为估算值，最终确认应以服务器返回规则为准。",
  "Ciclo Esmeraldas": "埃斯梅拉达斯周期",
  "Ciclo Cotopaxi": "科托帕希周期",
  "Ciclo Galápagos": "加拉帕戈斯周期",
  "Fondo Pacífico": "太平洋基金",
  "Fondo Andes": "安第斯基金",
  "Fondo Amazonía": "亚马逊基金",
  "Centro de operación": "运营中心",
  "Estado, rendimiento y tiempo restante de tus contratos.":
    "查看合约状态、收益与剩余时间。",
  "Equipos activos": "运行矿机",
  "Ingreso de hoy": "今日收益",
  "Precio de compra": "购买价格",
  "Saldo de fondos": "资金余额",
  Finalizado: "已结束",
  Todos: "全部",
  "En marcha": "运行中",
  "Por activar": "待激活",
  Finalizados: "已结束",
  Activar: "激活",
  "Ver detalle": "查看详情",
  "Catálogo activo": "在售目录",
  "Mercado de equipos": "矿机市场",
  "Compara capacidad, duración y rendimiento estimado antes de decidir.":
    "决策前对比算力、周期与预计收益。",
  Filtros: "筛选",
  "Mayor rendimiento": "较高收益",
  "Menor inversión": "较低投入",
  "Ciclo corto": "短周期",
  "Capacidad alta": "高算力",
  "Volver al mercado": "返回市场",
  "Potencia de cómputo": "算力",
  "Contrato de equipo": "矿机合约",
  "Una configuración equilibrada para distribuir capacidad de cómputo durante un ciclo definido.":
    "在固定周期内提供均衡算力配置。",
  "Inversión del contrato": "合约投入",
  "Ingreso diario estimado": "预计每日收益",
  "Ingreso total estimado": "预计总收益",
  "Panel de rendimiento diario": "每日收益面板",
  "Seguimiento del ciclo en tiempo real": "实时跟踪合约周期",
  "Registro completo de movimientos": "完整资金记录",
  "Continuar con la compra": "继续购买",
  "Revisa reglas, disponibilidad y condiciones antes de confirmar.":
    "确认前请查看规则、库存与条件。",
  "Comunidad GOP ALA": "GOP ALA 团队",
  "Consulta el tamaño y la actividad de tu comunidad, organizada por nivel.":
    "按层级查看团队规模与活跃情况。",
  "Miembros en 3 niveles": "三级团队成员",
  "La actividad se actualiza desde el servidor.": "活跃数据由服务器实时更新。",
  "No pudimos cargar el resumen del equipo.": "无法加载团队概览。",
  "Equipo directo": "直属团队",
  "Personas invitadas directamente por ti.": "由你直接邀请的成员。",
  "Segundo nivel": "二级团队",
  "Miembros conectados a tu equipo directo.": "由直属团队发展而来的成员。",
  "Tercer nivel": "三级团队",
  "Alcance ampliado de tu comunidad.": "团队网络的进一步扩展。",
  "Miembros del nivel": "层级成员",
  "Estado de activación de las personas que pertenecen a este nivel.":
    "查看本层级成员的激活状态。",
  "No pudimos cargar los miembros.": "无法加载成员。",
  "Miembro del nivel": "本级成员",
  "Este nivel aún está vacío": "本层级暂无成员",
  "Comparte tu enlace para ampliar tu comunidad.": "分享邀请链接以发展团队。",
  "Comparte tu enlace personal y acompaña a tu comunidad desde el primer paso.":
    "分享专属链接，从第一步开始陪伴团队成长。",
  "Mi enlace personal": "我的专属链接",
  "Crecer se siente mejor cuando es claro.": "清晰透明，成长更安心。",
  "Envía este enlace solo a personas que conozcan las condiciones del servicio.":
    "请仅向了解服务条款的人分享此链接。",
  "Consultando enlace…": "正在获取链接…",
  "Enlace no disponible": "链接不可用",
  "Copiar enlace": "复制链接",
  "Enlace copiado": "链接已复制",
  "Compartir invitación": "分享邀请",
  "Cómo funciona": "使用方式",
  "Tres pasos sencillos": "简单三步",
  "Comparte tu enlace": "分享链接",
  "El registro queda asociado a tu invitación.": "注册账户将与你的邀请关联。",
  "Tu contacto crea su cuenta": "好友创建账户",
  "Debe revisar y completar los datos solicitados.":
    "好友需要确认并填写所需资料。",
  "Sigue la actividad": "跟踪团队动态",
  "El nuevo miembro aparecerá en el nivel correspondiente.":
    "新成员将显示在相应层级。",
  "No prometas rentabilidad ni condiciones distintas a las publicadas por GOP ALA.":
    "请勿承诺与 GOP ALA 公布内容不一致的收益或条件。",
  "Únete a GOP ALA Ecuador": "加入 GOP ALA 厄瓜多尔",
  "Conoce GOP ALA y crea tu cuenta desde mi invitación.":
    "了解 GOP ALA，并通过我的邀请创建账户。",
  "Depositar fondos": "充值",
  "Elige un canal disponible, revisa el importe y confirma antes de salir al proveedor de pago.":
    "选择可用渠道，核对金额后再前往支付服务商。",
  "Monto a depositar": "充值金额",
  "Montos rápidos": "快捷金额",
  "Canal de pago": "支付渠道",
  "Consultando canales…": "正在获取支付渠道…",
  "No pudimos cargar los canales de pago.": "无法加载支付渠道。",
  "Procesamiento protegido por el proveedor": "由支付服务商安全处理",
  "Revisar depósito": "核对充值",
  "Confirma los datos": "确认信息",
  "Cambio referencial": "参考汇率",
  "Pago con control": "安全支付",
  "GOP ALA nunca solicita tu clave bancaria. Verifica el monto y el dominio del proveedor antes de continuar.":
    "GOP ALA 不会索要银行密码。继续前请核对金额及支付域名。",
  "Moneda base: dólar estadounidense": "基础货币：美元",
  "El canal se obtiene del servidor": "支付渠道由服务器提供",
  "La orden se crea una sola vez": "订单仅创建一次",
  "Billetera · Retiros": "钱包 · 提现",
  "Selecciona el saldo de origen y confirma el monto que deseas recibir en tu cuenta vinculada.":
    "选择余额来源，并确认转入绑定账户的金额。",
  "Monto a retirar": "提现金额",
  "El monto supera el saldo disponible.": "金额超过可用余额。",
  "Vincula un método de retiro": "绑定提现方式",
  "Necesitas una cuenta bancaria antes de solicitar un retiro.":
    "申请提现前需要绑定银行账户。",
  Vincular: "去绑定",
  "Revisar solicitud": "核对申请",
  "Resumen del retiro": "提现摘要",
  Origen: "资金来源",
  Solicitud: "申请金额",
  Solicitar: "提交申请",
  "El monto neto y cualquier comisión aplicable se confirmarán según las reglas vigentes del servidor.":
    "实际到账金额及手续费以服务器当前规则为准。",
  "Antes de retirar": "提现须知",
  "Los retiros pasan por revisión. La cuenta de destino debe pertenecer al titular registrado.":
    "提现需要审核，收款账户必须属于注册本人。",
  "Ver historial": "查看记录",
  "Historial de retiros": "提现记录",
  "Volver a retirar": "返回提现",
  "No pudimos cargar el resumen.": "无法加载摘要。",
  "Total recibido": "累计到账",
  Solicitudes: "申请记录",
  "Aún no hay retiros": "暂无提现记录",
  Recibido: "到账",
  Actividad: "资金动态",
  "Consulta depósitos, ingresos, compras y solicitudes de retiro desde un solo lugar.":
    "集中查看充值、收益、购买及提现申请。",
  "No pudimos cargar el historial.": "无法加载记录。",
  Movimiento: "资金变动",
  "Aún no hay movimientos": "暂无资金记录",
  "Las operaciones aparecerán aquí cuando se registren.":
    "发生操作后，记录将显示在这里。",
  "Saldo anterior": "变动前余额",
  "Saldo posterior": "变动后余额",
  "Seguridad financiera": "资金安全",
  "Método de retiro": "提现方式",
  "Administra la cuenta bancaria donde recibirás tus retiros.":
    "管理接收提现的银行账户。",
  "Consultando cuenta…": "正在获取账户…",
  "CUENTA VINCULADA": "已绑定账户",
  "Cuenta registrada": "账户已登记",
  "Se usará para los próximos retiros bancarios.": "后续银行提现将使用此账户。",
  "Editar información": "编辑信息",
  "La edición está bloqueada por la configuración de seguridad.":
    "当前安全设置不允许编辑。",
  "Nombre del titular": "账户持有人",
  Teléfono: "手机号",
  "Número de identificación": "身份证件号码",
  "Ingresa los 13 dígitos de tu documento": "请输入13位证件号码",
  "Documento de identidad (CI) requerido para procesar retiros bancarios en Ecuador.":
    "处理厄瓜多尔银行提现时必须提供身份文件（CI）。",
  "Institución financiera": "金融机构",
  "Selecciona un banco": "选择银行",
  "Número de cuenta": "银行账号",
  "Tipo o detalle de cuenta": "账户类型或备注",
  Opcional: "选填",
  "Ej. Cuenta de ahorros": "例如：储蓄账户",
  "Tus datos, protegidos": "保护你的信息",
  "Comprueba que el titular y el número de cuenta sean correctos. No mostramos controles de eliminación que el flujo original no habilitaba.":
    "请确认账户持有人及账号无误。原流程未开放删除，因此此处不提供删除操作。",
  "Simulación completada. En una cuenta real continuarías al proveedor de pago.":
    "模拟完成。真实账户将继续前往支付服务商。",
  "La orden se creó, pero el enlace de pago recibido no es válido.":
    "订单已创建，但返回的支付链接无效。",
  "Solicitud enviada. Puedes seguir su estado en el historial de retiros.":
    "申请已提交，可在提现记录中查看状态。",
  "Método de retiro guardado correctamente.": "提现方式已保存。",
  "Solicitud procesada correctamente.": "请求处理成功。",
  "Comprueba que el titular y el número de cuenta sean correctos antes de guardar.":
    "保存前请确认账户持有人和银行账号正确。",
  Volver: "返回",
  "Centro de premios": "奖励中心",
  "Aplicación oficial": "官方应用",
  "Selección de monto, canal y confirmación de pago.":
    "选择金额和支付渠道并确认付款。",
  "Saldo personal y del equipo con reglas visibles.":
    "清晰展示个人及团队余额规则。",
  "Historial unificado con filtros y estados.": "统一记录、筛选及状态展示。",
  "Gestión segura de información bancaria.": "安全管理银行信息。",
  "Código, enlace, QR y opciones para compartir.":
    "邀请码、链接、二维码及分享选项。",
  "Actividad y miembros organizados por nivel.": "按层级整理团队动态及成员。",
  "Saldo de puntos, origen y canjes disponibles.": "积分余额、来源及可用兑换。",
  "Sorteos, reglas y registro de resultados.": "抽奖、规则及结果记录。",
  "Avisos importantes sobre tu cuenta.": "账户重要通知。",
  "Datos personales, avatar, nombre y contraseña.":
    "个人资料、头像、名称及密码。",
  "Acceso al canal oficial de soporte configurado por el servidor.":
    "访问服务器配置的官方客服渠道。",
  "Descarga de Android o acceso de iOS según el dispositivo.":
    "根据设备下载 Android 或访问 iOS 版本。",
  "Beneficios diarios": "每日福利",
  "Asistencia diaria": "每日签到",
  "Completa la secuencia y recibe puntos en cada jornada.":
    "连续签到，每天领取积分奖励。",
  "Progreso semanal": "本周进度",
  "Puntos recibidos": "已获积分",
  "Próxima recompensa": "下一奖励",
  "Completado hoy": "今日已完成",
  "Registrar asistencia": "立即签到",
  "Asistencia registrada correctamente.": "签到成功。",
  "Esta semana": "本周",
  "Recompensas por día": "每日奖励",
  "Cargando…": "加载中…",
  Día: "第",
  puntos: "积分",
  "Consulta avisos y novedades relacionados con tu cuenta.":
    "查看与你的账户相关的通知和动态。",
  "Cargando mensajes…": "正在加载消息…",
  "No pudimos cargar los mensajes.": "无法加载消息。",
  "No tienes mensajes nuevos": "暂无新消息",
  "Los avisos de tu cuenta aparecerán aquí.": "账户通知将显示在这里。",
  "Tu actividad y los movimientos recientes ya están disponibles.":
    "你的活动与近期资金记录已经更新。",
  "Seguridad de la cuenta": "账户安全",
  "Recuerda verificar el dominio antes de confirmar cualquier operación.":
    "确认任何操作前，请核对访问域名。",
  "Puntos y beneficios": "积分与福利",
  "Centro de puntos": "积分中心",
  "Convierte puntos y saldo con las tasas disponibles en tu cuenta.":
    "按照当前账户汇率兑换积分与余额。",
  "Puntos a saldo": "积分转余额",
  "Saldo a puntos": "余额转积分",
  "Cantidad de puntos": "积分数量",
  PTS: "积分",
  "Tasa actual": "当前汇率",
  "Recibirás aproximadamente": "预计获得",
  "Conversión completada.": "兑换成功。",
  Convertir: "确认兑换",
  "Historial de puntos": "积分记录",
  "Perfil y acceso": "资料与登录",
  "Cambiar foto": "更换头像",
  "Foto actualizada.": "头像已更新。",
  "Selecciona una imagen JPG, PNG o WebP.": "请选择 JPG、PNG 或 WebP 图片。",
  "La imagen no puede superar 5 MB.": "图片不能超过 5 MB。",
  "Administra tu nombre visible y la contraseña de acceso.":
    "管理显示名称与登录密码。",
  "Número no disponible": "号码不可用",
  "Información personal": "个人信息",
  "Nombre visible": "显示名称",
  "Nombre actualizado.": "名称已更新。",
  "Guardar cambios": "保存修改",
  Acceso: "登录安全",
  "Cambiar contraseña": "修改密码",
  "Contraseña actual": "当前密码",
  "Nueva contraseña": "新密码",
  "Confirmar contraseña": "确认密码",
  "Las contraseñas no coinciden.": "两次输入的密码不一致。",
  "Contraseña actualizada.": "密码已更新。",
  "Actualizar contraseña": "更新密码",
  Ayuda: "帮助",
  "Comunícate con el equipo de soporte a través del canal oficial.":
    "通过官方渠道联系客户支持。",
  "¿En qué podemos ayudarte?": "需要什么帮助？",
  "Nuestro equipo atiende consultas relacionadas con tu cuenta, operaciones y seguridad.":
    "我们的团队可协助处理账户、资金操作与安全问题。",
  "Abrir soporte": "联系客服",
  Seguridad: "安全",
  "Acceso, contraseña y protección de la cuenta.": "登录、密码与账户保护。",
  Operaciones: "资金操作",
  "Depósitos, retiros y movimientos de saldo.": "充值、提现与余额记录。",
  "Datos personales, equipo y beneficios.": "个人资料、团队与福利。",
  "Aplicación GOP ALA": "GOP ALA 应用",
  "Elige la versión correspondiente a tu dispositivo.":
    "请选择适合设备的版本。",
  "Tu cuenta, siempre disponible": "随时管理你的账户",
  "Accede a tus equipos, saldo y movimientos desde la aplicación oficial.":
    "通过官方应用查看矿机、余额与资金记录。",
  "No pudimos obtener los enlaces de descarga.": "无法获取下载链接。",
  "Participa y consulta los resultados recientes.": "参与抽奖并查看近期结果。",
  "Elige tu momento": "开启你的好运",
  cupón: "张优惠券",
  "Sigue participando": "再接再厉",
  Participar: "立即参与",
  Resultado: "抽奖结果",
  Cerrar: "关闭",
  Aviso: "公告",
  Carrusel: "轮播图",
  Novedades: "最新动态",
  Siguiente: "下一张",
  "Ir a la imagen": "转到图片",
  Servicios: "服务",
  "Tiempo de operación": "运行时间",
  Horas: "小时",
  Minutos: "分钟",
  Segundos: "秒",
  "Código de verificación": "验证码",
  "Enviar código": "发送验证码",
  "Código enviado.": "验证码已发送。",
  "Ingresa el código de verificación.": "请输入验证码。",
  "Ingresa el código de invitación.": "请输入邀请码。",
  "No pudimos cargar la configuración de registro.": "无法加载注册配置。",
  "Finaliza en": "距离结束",
  Reglas: "规则",
  "Nivel 1 activo": "一级活跃",
  "Nivel 2 activo": "二级活跃",
  "Nivel 3 activo": "三级活跃",
  "Actividad reciente": "近期动态",
  "Últimos ganadores": "最新获奖用户",
  "Usuario GOP ALA": "GOP ALA 用户",
  "Mi historial": "我的记录",
  "Volver al sorteo": "返回抽奖",
  "Aún no hay participaciones": "暂无参与记录",
  "Sin premio": "未中奖",
  Obtenido: "已获得",
  "Volver a premios": "返回奖励中心",
  "Beneficios GOP ALA": "GOP ALA 福利",
  "Administra tus beneficios desde un solo lugar.": "集中管理你的积分与奖励。",
  "Convierte puntos y consulta sus movimientos.": "兑换积分并查看积分记录。",
  "Participa y revisa los resultados recientes.": "参与抽奖并查看近期结果。",
  "Mis cupones": "我的优惠券",
  "Consulta cupones disponibles y utilizados.": "查看可用及已使用的优惠券。",
  "Canjear CDK": "兑换 CDK",
  "Ingresa un código y recibe su beneficio.": "输入代码领取对应奖励。",
  "Código de regalo": "礼品码",
  "Abre regalos y consulta el historial.": "开启礼品并查看领取记录。",
  "Consulta el valor y el estado de tus cupones.": "查看优惠券面额和使用状态。",
  Disponibles: "可使用",
  Utilizados: "已使用",
  "Cupón de descuento": "优惠券",
  Disponible: "可使用",
  Utilizado: "已使用",
  "No hay cupones": "暂无优惠券",
  "Tus cupones aparecerán aquí.": "你的优惠券将显示在这里。",
  "Ingresa el código exactamente como aparece.": "请准确输入所显示的代码。",
  "Código CDK": "CDK 代码",
  "Código canjeado": "兑换成功",
  "Canjear código": "确认兑换",
  "Historial CDK": "CDK 兑换记录",
  "Ingresa tu código para recibir el beneficio asociado.":
    "输入礼品码领取对应奖励。",
  "Abre tu regalo": "开启礼物",
  "Cada código válido puede utilizarse una sola vez.":
    "每个有效代码只能使用一次。",
  Recibiste: "你已获得",
  "Abrir regalo": "开启礼物",
  "Historial de regalos": "礼品记录",
  "Sin registros": "暂无记录",
  "Historial de conversiones": "兑换记录",
  "Consulta las conversiones realizadas entre puntos y saldo.":
    "查看积分与余额之间的兑换记录。",
  "Revisa conversiones anteriores entre puntos y saldo.":
    "查看之前的积分与余额兑换记录。",
  Consumido: "消耗",
  "Computación en la nube": "云算力",
  Minería: "矿机",
  Ordenar: "排序",
  Recomendados: "推荐",
  "Cargando equipos…": "正在加载设备…",
  "No pudimos cargar los equipos.": "无法加载设备。",
  "No hay equipos disponibles": "暂无可用设备",
  "Cargando equipo…": "正在加载设备…",
  "Equipo no disponible": "设备不可用",
  Cantidad: "数量",
  Máximo: "最多",
  "Reducir cantidad": "减少数量",
  "Aumentar cantidad": "增加数量",
  "Cupón disponible": "可用优惠券",
  Total: "总计",
  "Compra completada correctamente.": "购买成功。",
  "Confirmar compra": "确认购买",
  "Saldo insuficiente.": "余额不足。",
  "No pudimos cargar tus equipos.": "无法加载你的设备。",
  "No tienes equipos activos": "暂无运行中的设备",
  "No tienes equipos finalizados": "暂无已结束设备",
  Vender: "出售",
  "Confirmar activación": "确认激活",
  "Confirmar venta": "确认出售",
  "Inicia sesión para consultar los equipos disponibles":
    "登录后查看当前可用设备",
  "Monto invertido": "已投资金额",
  "Saldo de moneda": "代币余额",
  "Beneficio acumulado": "累计收益",
  "No pudimos cargar los productos financieros.": "无法加载理财产品。",
  "Inicia sesión para consultar los productos disponibles":
    "登录后查看当前可用产品",
  "Ingreso estimado": "预计收益",
  "Límite de compra": "购买限制",
  Inversión: "投资金额",
  Comprar: "购买",
  "No hay productos disponibles": "暂无可用产品",
  "Confirmar inversión": "确认投资",
  "Ingresos del equipo": "团队收益",
  Reclutamiento: "招募矿工",
  "Sobre GOP ALA": "关于 GOP ALA",
  "Perfil de la empresa": "公司资料",
  Anterior: "变动前",
  Actual: "当前",
  "No hay registros": "暂无记录",
  "No pudimos cargar el contenido.": "无法加载内容。",
  "No pudimos cargar los movimientos.": "无法加载资金记录。",
  "Depositar en fondos": "充值到基金账户",
  "Transferir saldo del equipo": "转入团队余额",
  "Transferencia completada.": "转账成功。",
  Continuar: "继续",
  "Confirmar transferencia": "确认转账",
  "Cargar más": "加载更多",
};

const dictionaries: Record<AppLanguage, Dictionary> = { es: {}, en };

function interpolate(value: string, values?: Values) {
  return values
    ? value.replace(/\{\{(\w+)\}\}/g, (_, key: string) =>
        String(values[key] ?? ""),
      )
    : value;
}

export function useCopy() {
  const { i18n } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || "es").split(
    "-",
  )[0] as AppLanguage;
  const tr = (spanish: string, values?: Values) =>
    interpolate(dictionaries[language]?.[spanish] || spanish, values);
  return { tr, language };
}
